export const SET_ACTIVE_COMPONENT = 'SET_ACTIVE_COMPONENT';
export const CLEAR_ACTIVE_COMPONENT_OPTIONS = 'CLEAR_ACTIVE_COMPONENT_OPTIONS';
